'use client'

import { Settings } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Switch } from '@/components/ui/switch'

export default function SystemSettings() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Settings className="h-6 w-6" />
        <h2 className="text-2xl font-bold">시스템 설정</h2>
      </div>

      <Tabs defaultValue="mail" className="w-full">
        <TabsList>
          <TabsTrigger value="mail">메일 설정</TabsTrigger>
          <TabsTrigger value="integration">외부 연동</TabsTrigger>
        </TabsList>

        <TabsContent value="mail" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>SMTP 설정</CardTitle>
              <CardDescription>이메일 발송을 위한 SMTP 서버를 설정합니다</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid gap-4 md:grid-cols-2">
                <div className="space-y-2">
                  <Label>SMTP 서버</Label>
                  <Input placeholder="smtp.example.com" />
                </div>
                <div className="space-y-2">
                  <Label>포트</Label>
                  <Input placeholder="587" />
                </div>
                <div className="space-y-2">
                  <Label>사용자명</Label>
                  <Input placeholder="user@example.com" />
                </div>
                <div className="space-y-2">
                  <Label>비밀번호</Label>
                  <Input type="password" placeholder="••••••••" />
                </div>
              </div>
              <Button>저장</Button>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="integration" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>결제 PG 설정</CardTitle>
              <CardDescription>PG사 연동 설정을 관리합니다</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <Label>테스트 모드</Label>
                  <p className="text-sm text-muted-foreground">테스트 환경에서 결제 테스트</p>
                </div>
                <Switch defaultChecked />
              </div>
              <div className="grid gap-4 md:grid-cols-2">
                <div className="space-y-2">
                  <Label>가맹점 ID (테스트)</Label>
                  <Input defaultValue="demo@coffeeshop.com" />
                </div>
                <div className="space-y-2">
                  <Label>API Key (테스트)</Label>
                  <Input type="password" defaultValue="test_api_key_12345" />
                </div>
              </div>
              <Button>저장</Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>로봇 배송 API 연동</CardTitle>
              <CardDescription>로봇 배송 서비스 연동 설정</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid gap-4 md:grid-cols-2">
                <div className="space-y-2">
                  <Label>API Endpoint</Label>
                  <Input placeholder="https://api.robot-delivery.com" />
                </div>
                <div className="space-y-2">
                  <Label>API Key</Label>
                  <Input type="password" placeholder="••••••••" />
                </div>
              </div>
              <Button>저장</Button>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  )
}
